import { render, staticRenderFns } from "./tree.editor.vue?vue&type=template&id=16d4abf8&"
import script from "./tree.editor.vue?vue&type=script&lang=ts&"
export * from "./tree.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports